import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-background px-4 py-16">
      <div className="max-w-2xl w-full text-center">
        <p className="text-sm font-semibold tracking-widest uppercase text-secondary mb-4">
          Error 404
        </p>
        <h1
          className="text-7xl md:text-9xl font-extrabold leading-none mb-6"
          style={{ color: "#000080" }}
        >
          404
        </h1>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
          This page took a different path.
        </h2>
        <p className="text-base md:text-lg text-muted-foreground mb-2 max-w-xl mx-auto">
          The page you're looking for doesn't exist, has been moved, or the link you
          followed may be outdated.
        </p>
        <p className="text-sm text-muted-foreground/80 mb-10 font-mono break-all">
          Requested: <span className="text-foreground/70">{location.pathname}</span>
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-12">
          <Button asChild size="lg" style={{ backgroundColor: "#000080" }}>
            <Link to="/">
              <Home className="mr-2 h-4 w-4" />
              Return Home
            </Link>
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        </div>

        <div className="border-t border-border pt-8">
          <p className="text-sm text-muted-foreground mb-4 flex items-center justify-center gap-2">
            <Search className="h-4 w-4" />
            You may find what you need here:
          </p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm">
            <Link to="/about-us" className="text-foreground hover:text-secondary transition-colors">
              About
            </Link>
            <Link to="/founder-profile" className="text-foreground hover:text-secondary transition-colors">
              Founder
            </Link>
            <Link to="/brochures" className="text-foreground hover:text-secondary transition-colors">
              Brochures & Publications
            </Link>
            <Link to="/mentorship" className="text-foreground hover:text-secondary transition-colors">
              Mentorship
            </Link>
            <Link to="/contact" className="text-foreground hover:text-secondary transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
